import {Component, HostListener, OnInit} from '@angular/core';
import {ProfileMenuItem} from "./layouts/profile-menu/profile-menu-item.enum";
import {ProfileRouterUtil} from "./profile-router.util";

@Component({
  selector: 'app-profile-settings',
  templateUrl: './profile-settings.component.html',
  styleUrls: ['./profile-settings.component.css']
})
export class ProfileSettingsComponent implements OnInit {

  protected isMobile: boolean = false;

  constructor(
    private readonly profileRouterUtil: ProfileRouterUtil
  ) {
  }

  ngOnInit(): void {
    this.isMobile = window.innerWidth <= 1220;
  }

  get getMenuItems(): Array<ProfileMenuItem> {
    return this.profileRouterUtil.getMenuItems;
  }

  protected isRouteActive(item: ProfileMenuItem): boolean {
    return this.profileRouterUtil.isRouteActive(item);
  }

  protected navigateToPage(item: ProfileMenuItem): void {
    this.profileRouterUtil.navigateToPage(item);
  }

  @HostListener('window:resize')
  private onWindowResize() {
    this.isMobile = window.innerWidth <= 1220;
  }
}
